import { IManagementTokenRepository } from "../../domain/system";
import { AuthenticatedService } from "..";

export class ManagementTokenRepository extends AuthenticatedService implements IManagementTokenRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async extend(managementToken: string): Promise<void> {
    if (!managementToken) { throw new Error("managementToken is empty!!!"); }
    await this.post("api/management-token/" + managementToken + "/extend");
  }

  async delete(managementToken: string): Promise<void> {
    if (!managementToken) { throw new Error("managementToken is empty!!!"); }
    await this.post("api/management-token/" + managementToken + "/delete");
  }
}
